(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-evofox"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall) {
        if (this.sticky() || this.header.classList.contains('shopify-section-header-hidden')) {
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall) {
        if (this.sticky() || this.header.classList.contains('shopify-section-header-hidden')) {
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function () {
    const referrer = document.referrer;

    // Normalize referrer to just the path
    const parser = document.createElement('a');
    parser.href = referrer;
    const refPath = parser.pathname;

    const currentPath = window.location.pathname;

    if (currentPath === "/account") {
      if (refPath === "/pages/join-the-tribe") {
        window.location.href = "https://amkette.com/pages/join-the-tribe";
      } else if (refPath === "/pages/product-registration") {
        window.location.href = "https://amkette.com/pages/product-registration";
      }else if (refPath === "/account/login?view=support") {
        window.location.href = "https://amkette.com//account/login?view=support";
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-slider"] && !Shopify.designMode) return;
  try {
    
   $('div.product-slideshow').owlCarousel({
     loop:true,
     margin:5,
     autoplay: true,
     nav:false,
     autowidth: true,
     responsive:{
         0:{
             items:2
         },
         600:{
             items:3
         },
         1000:{
             items:5
         }
     }
   })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-homepage-newlaunch"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.product-card-wrapper').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive:{
      0:{ items: 1 },
      560:{ items: 2 },
      960:{ items: 3 },
      1200:{ items: 4 },
      1600:{ items: 4 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-best-of-amkette"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const collectionLinks = document.querySelectorAll('.collection-link');
    const productCards = document.querySelectorAll('.product-card-custom.filterable');
     const viewAllLink = document.querySelector('.view_all_text_link');

    // Function to filter product cards based on selected collection handle
    function filterProductCards(selectedCollectionHandle) {
        productCards.forEach(function(card) {
            const cardCollectionHandle = card.getAttribute('data-collection-handle');
            if (selectedCollectionHandle === cardCollectionHandle || selectedCollectionHandle === 'all') {
                card.style.display = 'block';
            } else {
                card.style.display = 'none';
            }
        });
        // Update the href attribute of the view all link
        viewAllLink.href = `/collections/${selectedCollectionHandle}`;
    }

    // Event listener for collection links
    collectionLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const selectedCollectionHandle = this.getAttribute('data-collection-handle');

            // Remove 'selected' class from all links
            collectionLinks.forEach(function(link) {
                link.classList.remove('selected');
            });

            // Add 'selected' class to the clicked link
            this.classList.add('selected');

            filterProductCards(selectedCollectionHandle);
        });
    });

    // Preselect the filterable link with the class 'evofox-gaming' and add 'selected' class
    const preselectedLink = document.querySelector('.collection-link.evofox-gaming');
    if (preselectedLink) {
        const preselectedCollectionHandle = preselectedLink.getAttribute('data-collection-handle');
        preselectedLink.classList.add('selected');
        filterProductCards(preselectedCollectionHandle);
    }
});

 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-homepage"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
  $('.product-card-wrapper').owlCarousel({
    loop: true, // Makes the carousel loop
    margin: 10, // Adds a margin between items
    nav: true,  // Shows navigation arrows
     // autoWidth: true,
    responsive:{
      0:{
        items: 1 // Items to show at width 0px and up
      },
      560:{
        items: 2 // Items to show at width 0px and up
      },
      960:{
        items: 3 // Items to show at width 600px and up
      },
      1200:{
        items: 4 // Items to show at width 1000px and up
      },
       1600:{
        items: 4 // Items to show at width 600px and up
      }
    }
  });
});

  
  document.addEventListener('DOMContentLoaded', function() {
        const variantButtons = document.querySelectorAll('.variant-swatch');

        variantButtons.forEach(button => {
            button.addEventListener('click', function() {
                const variantId = button.dataset.variantId;
                const variant = select_product.variants.find(v => v.id == variantId);
                const imageUrl = variant.image.src;

                document.getElementById('product-image').src = imageUrl;
            });
        });
    });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    

    $('div.owl-carousel-2').owlCarousel({
      loop: true,
      margin: 5,
      autoplay: false,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 3
        },
        600: {
          items: 4
        },
        1000: {
          items: 8
        }
      }
    });

   
  });

  } catch(e) { console.error(e); }
})();
})();
